import { __decorate } from "tslib";
import React from "react";
import { observer, inject } from "mobx-react";
import { TileApiInterfaceContext } from "./tile-api";
import { BaseComponent } from "../base";
import "./tile-comments.scss";
let TileCommentsComponent = class TileCommentsComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "renderDelete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (comment) => {
                return (React.createElement("div", { className: "delete", title: "Delete", onClick: this.handleDelete(comment) },
                    React.createElement("svg", { className: `icon icon-delete-tool` },
                        React.createElement("use", { xlinkHref: `#icon-delete-tool` }))));
            }
        });
        Object.defineProperty(this, "handleDelete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (comment) => () => {
                comment.delete();
            }
        });
        Object.defineProperty(this, "closeComments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { model } = this.props;
                model.setVisible(false);
            }
        });
        Object.defineProperty(this, "openComments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { model } = this.props;
                model.setVisible(true);
            }
        });
    }
    render() {
        const { user } = this.stores;
        const { model } = this.props;
        if (!model.comments.length)
            return null;
        if (!model.visible) {
            return this.renderClosed();
        }
        const { class: clazz } = this.stores;
        return (React.createElement("div", { className: "tile-comments open" },
            React.createElement("div", { className: "close", title: "Close", onClick: this.closeComments },
                React.createElement("svg", { className: `icon icon-delete-tool` },
                    React.createElement("use", { xlinkHref: `#icon-delete-tool` }))),
            React.createElement("div", { className: "comments" },
                React.createElement("div", { className: "title" }, "Comments"),
                model.comments.map(comment => {
                    const student = clazz.getUserById(comment.uid);
                    const name = student ? student.displayName : "Student";
                    return (React.createElement("div", { className: "comment", key: comment.key },
                        user.id === comment.uid ? this.renderDelete(comment) : null,
                        `${name}: ${comment.text}`));
                }))));
    }
    renderClosed() {
        return (React.createElement("div", { className: "tile-comments closed", title: "Close", onClick: this.openComments },
            React.createElement("svg", { className: `icon icon-geometry-comment` },
                React.createElement("use", { xlinkHref: `#icon-geometry-comment` }))));
    }
};
Object.defineProperty(TileCommentsComponent, "contextType", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: TileApiInterfaceContext
});
TileCommentsComponent = __decorate([
    inject("stores"),
    observer
], TileCommentsComponent);
export { TileCommentsComponent };
//# sourceMappingURL=data:application/json;base64,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